var _rect, _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentsPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.9,
    y: 0.9,
    width: 22.2,
    height: 20.2,
    rx: 1.1,
    stroke: "#43927C",
    strokeWidth: 1.8
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 5.53906,
    y1: 7.25,
    x2: 18.4621,
    y2: 7.25,
    stroke: "#43927C",
    strokeWidth: 1.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 7.38477,
    y1: 11.25,
    x2: 16.6155,
    y2: 11.25,
    stroke: "#43927C",
    strokeWidth: 1.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 5.53906,
    y1: 15.25,
    x2: 18.4621,
    y2: 15.25,
    stroke: "#43927C",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentsPage);
export default __webpack_public_path__ + "static/media/documentsPage.f437dd8ffec3f35c4a1f9072b3a5c0c3.svg";
export { ForwardRef as ReactComponent };